/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   4/26/22
 */

import {gql} from "urql";
import {EventSubscription, EventSubscriptionConfig} from "../../interfaces/Global";

export const CreateEventSubscriptionMutation = gql`
    mutation CreateEventSubscription($data: EventSubscriptionInput!) {
        createEventSubscription(data: $data) {
            id
            creationDate
            createdBy
            modifiedDate
            modifiedBy
	        enabled
	        lastTriggered
	        triggerCount
            config
            vstamp
        }
    }
`;

export const UpdateEventSubscriptionMutation = gql`
    mutation UpdateEventSubscription($id: Int!, $data: EventSubscriptionInput!) {
        updateEventSubscription(id: $id, data: $data) {
            id
            creationDate
            createdBy
            modifiedDate
            modifiedBy
            enabled
            lastTriggered
            triggerCount
            config
            vstamp
        }
    }
`;

export const DeleteEventSubscriptionMutation = gql`
    mutation DeleteEventSubscription($id: Int!) {
        deleteEventSubscription(id: $id)
    }
`;

export interface DeleteEventSubscriptionResponse {
	deleteEventSubscription: boolean
}

export interface DeleteEventSubscriptionVars {
	id: number
}

export interface CreateEventSubscriptionResponse {
	createEventSubscription: EventSubscription
}

export interface CreateEventSubscriptionVars {
	data: EventSubscriptionInput
}

export interface UpdateEventSubscriptionResponse {
	updateEventSubscription: EventSubscription
}

export interface UpdateEventSubscriptionVars {
	id: number
	data: EventSubscriptionInput
}

export interface EventSubscriptionInput {
	enabled?: boolean
	config?: EventSubscriptionConfig
}